/**
 * @ngdoc module
 * @name vrm.core
 * @description VRM core module
 */

(function() {
    'use strict';

    angular.module('vrm.core')
        .config(InstallationOverviewConfig);

    /**
     * @constructor
     * @ngInject
     */
    function InstallationOverviewConfig($stateProvider) {

        // set available routes
        $stateProvider
            .state('base.installation-overview', {
                url: '/installation-overview'
                    + '?search'
                    + '&{alarms:bool}'
                    + '&{demo-login:bool}'
                    + '&{isMapOpen:bool}'
                    + '&tags'
                    // Map
                    + '&location'
                    + '&{service:bool}'
                    + '&{tank:bool}'
                    + '&markers'
                    // Filter Bar
                    + '&battery-state'
                    + '&battery-soc'
                    + '&battery-voltage'
                    + '&solar-solar'
                    + '&load-load'
                    + '&grid-grid'
                    + '&generator-state'
                    + '&generator-generator'
                    + '&generator-runtime'
                    + '&generator-running'
                    + '&tank-type'
                    + '&tank-level'
                    + '&temperature-type'
                    + '&temperature-temperature'
                    + '&last_timestamp-time'
                    + '&teams-team'
                    + '&groups-groups'
                    + '&tags-tags'
                    + '&alarm-alarm',
                params: {
                    justSignedIn: null,
                },
                views: {
                    "main": {
                        template: require('@/angular/views/core/installation-overview.html'),
                        controller: 'InstallationOverviewController'
                    }
                },
                dynamic: true,
                data:{
                    sharedCanAccess:true
                }

            });
    }

})();
